<template>
  <div>
    <b-modal
      id="addCandToJob"
      centered
      hide-footer
      hide-header
      no-close-on-backdrop
      :visible="showAddCands"
      @hidden="closeModal()"
    >
      <!-- <b-overlay :show="showSpinner" rounded="sm"> -->
      <div>
        <div class="d-flex align-items-center justify-content-between p-3">
          <div class="b-modal-header">Add Candidates to Job</div>
          <div class="rotate-on-hover pointer">
            <img
              :class="showSpinner && 'disabled-kanban-img'"
              @click="!showSpinner && closeModal()"
              v-b-tooltip.hover.top="'Close'"
              src="../../../assets/img/accessconnew/blueCross.svg"
              alt
            />
          </div>
        </div>
        <hr class="my-0" />
        <div class="set-padding">
          <div class="d-flex align-items-center">
            <div class="set-w-px">
              <img
                src="../../../assets/new-kanban-icons/success-icon.svg"
                alt=""
              />
            </div>
            <div>
              <div class="addTocandJob-head">
                In which trend should candidates be added to a job?
              </div>
              <div class="addTocandJob-subhead">
                Choose 'Assign Automatically' for auto-assignment or assign
                manually.
              </div>
            </div>
          </div>
          <div class="mt-3 d-flex align-items-center">
            <div class="set-w-px"></div>
            <b-form-group>
              <div
                class="
                  d-flex
                  align-items-center
                  new-center-radio
                  tp-jd-card-overflow-selected
                "
              >
                <div>
                  <b-form-radio
                    v-model="assignType"
                    value="1"
                    class="postype-text"
                    >Assign Automatically</b-form-radio
                  >
                </div>
                <div>
                  <b-form-radio
                    v-model="assignType"
                    class="ml-4 postype-text"
                    value="2"
                    >Assign Manually</b-form-radio
                  >
                </div>
              </div>
            </b-form-group>
          </div>
        </div>
        <hr />
        <div
          class="
            d-flex
            align-items-center
            justify-content-end
            w-100
            bluebtn
            mb-3
          "
        >
          <b-button
            class="acs-cancelBtn-modal mr-3"
            :disabled="assignType == 1 && showSpinner"
            @click="!showSpinner && closeModal()"
            >Cancel</b-button
          >
          <div class="position-relative">
            <b-button
              class="acs-addBtn-modal pl-4 pr-4 mr-3 w-110"
              :class="
                showSpinner ? 'upload-loader-class defaultCursor' : 'pointer'
              "
              :disabled="!assignType"
              @click="assignType && !showSpinner && gotoPosition()"
              >{{ showSpinner && assignType == 1 ? "" : "Continue" }}</b-button
            >
            <div
              v-if="showSpinner && assignType == 1"
              class="upload-loader-pos"
            >
              <Loader />
            </div>
          </div>
        </div>
      </div>
      <!-- </b-overlay> -->
    </b-modal>
  </div>
</template>

<script>
import Loader from "../../../components/fixedcomponents/Loader.vue";
export default {
  name: "AddCandidatesToJob",
  props: {
    showAddCands: Boolean,
    failure: Boolean,
  },
  data() {
    return {
      showSpinner: false,
      assignType: null,
    };
  },
  components: {
    Loader,
  },
  watch: {
    failure(val) {
      if (val) {
        this.showSpinner = false;
        this.$emit("change-failure");
      }
    },
  },
  methods: {
    gotoPosition() {
      if (this.assignType == 1) {
        this.showSpinner = true;
      }
      this.$emit("go-to-position", this.assignType);
    },
    closeModal() {
      this.assignType = null;
      this.$emit("close-modal");
    },
  },
};
</script>

<style>
.addTocandJob-head {
  font-family: "Lato", sans-serif;
  font-style: normal;
  font-weight: 500;
  font-size: 16px;
  line-height: 25px;
  color: #333333;
}

.addTocandJob-subhead {
  font-family: "Montserrat", sans-serif;
  font-style: italic;
  font-weight: 500;
  font-size: 11px;
  line-height: 20px;
  color: #70737b;
}

.set-padding {
  padding: 15px 30px;
}

.set-w-px {
  width: 60px;
}

#addCandToJob .modal-body {
  padding: 0px;
}

.upload-loader-class {
  opacity: 0.5;
  height: 29px;
  width: 110px;
}

.upload-loader-pos {
  position: absolute;
  top: -54px;
  z-index: 1;
  left: 11px;
}

.postype-text .custom-control-label {
  font-family: "Lato", sans-serif;
  font-weight: 500;
  font-size: 14px;
  color: #3a3c40;
  padding-left: 5px;
}
</style>
